import { TypedBroadcastChannel } from './typed-broadcast-channel';

/**
 * Posts a single message to all listeners on a named channel, then immediately closes
 * the channel.
 *
 * Use this for fire-and-forget broadcasts where no persistent listener is needed on the
 * sending side. For persistent listeners, use {@link TypedBroadcastChannel} directly.
 *
 * @template TMessage - The type of the message to broadcast.
 * @param name - The channel name to broadcast on.
 * @param message - The typed message to post.
 *
 * @example
 * ```ts
 * broadcastOnce<AuthMessage>('datastream:auth', { type: 'logout' });
 * ```
 */
export const broadcastOnce = <TMessage>(name: string, message: TMessage): void => {
  const channel = new TypedBroadcastChannel<TMessage>(name);

  channel.post(message);
  channel.close();
};
